import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="overline"
          align="center"
          display="block"
          sx={{ letterSpacing: '0.35em', color: 'text.secondary', mb: 1 }}
        >
          Allure · Paris
        </Typography>
        <Divider sx={{ my: 2, opacity: 0.5 }} />
        <Typography variant="body2" color="text.secondary" align="center" sx={{ letterSpacing: '0.06em' }}>
          © {new Date().getFullYear()} Allure · Location de robes entre particulières.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
